import { render, staticRenderFns } from "./PotentialCustomerView.vue?vue&type=template&id=3d86bf76&"
import script from "./PotentialCustomerView.vue?vue&type=script&lang=js&"
export * from "./PotentialCustomerView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports